import * as React from 'react';
import type { SVGProps } from 'react';
const SvgRoi = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 21 21"
    {...props}
  >
    <path d="M3.036 4.096a1 1 0 0 1 1-1H9.5a1 1 0 0 1 1 1V5.28a1 1 0 0 1-1 1H4.036a1 1 0 0 1-1-1zm4.283 5.355a1 1 0 0 1 1-1h8.735a1 1 0 0 1 1 1v1.185a1 1 0 0 1-1 1H8.319a1 1 0 0 1-1-1zm4.814 5.694a1 1 0 0 1 1-1h3.921a1 1 0 0 1 1 1v1.185a1 1 0 0 1-1 1h-3.92a1 1 0 0 1-1-1v-1.185Z" />
  </svg>
);
export default SvgRoi;
